import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const JeaCheckbox = React.forwardRef(
  ({ className, checked = false, onChange, id, label, description, ...props }, ref) => {
    return (
      <label
        htmlFor={id}
        className={cn("inline-flex items-start gap-3 cursor-pointer select-none", className)}
      >
        <button
          ref={ref}
          id={id}
          type="button"
          role="checkbox"
          aria-checked={checked}
          onClick={() => onChange && onChange(!checked)}
          className={cn(
            "mt-[2px] flex h-5 w-5 shrink-0 items-center justify-center rounded-[6px] border transition-all duration-150",
            checked
              ? "bg-accent-pink border-accent-pink"
              : "bg-bg-tertiary border-border-default hover:border-accent-pink/60"
          )}
          {...props}
        >
          {checked && <Check size={14} strokeWidth={3} className="text-[#091424]" />}
        </button>
        {(label || description) && (
          <span className="text-[13px] leading-5 text-text-secondary">
            {label}
            {description && (
              <span className="block text-text-muted text-[12px]">{description}</span>
            )}
          </span>
        )}
      </label>
    );
  }
);
JeaCheckbox.displayName = "JeaCheckbox";

export { JeaCheckbox };
export default JeaCheckbox;
